
















































import Vue from 'vue'

export default Vue.extend({
  name: 'talent-item',
  props: {
    talent: {
      type: Object,
      required: true,
    },
    pilotRank: {
      type: Number,
      required: true,
    },
    newPilot: {
      type: Boolean,
      required: false,
    },
    available: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    step: 'I',
  }),
  watch: {
    pilotRank(newval, oldval) {
      if (newval < oldval) this.step = 'I'.repeat(this.pilotRank + 1)
    },
  },
  created() {
    if (this.pilotRank === 1) this.step = 'II'
    else if (this.pilotRank > 1) this.step = 'III'
  },
  methods: {
    add(): void {
      this.$emit('add')
      if (!this.newPilot && this.step !== 'III') this.step += 'I'
    },
    remove(): void {
      this.$emit('remove')
      if (!this.newPilot && this.step !== 'I') this.step = this.step.substring(1)
    },
  },
})
